export default __webpack_public_path__ + "static/media/about-2.728a9daa.jpg";